// ACTION CREATOR SET_OPEN_COMMAND_LINE_CLIENT_MODAL
export const SET_OPEN_COMMAND_LINE_CLIENT_MODAL = 'SET_OPEN_COMMAND_LINE_CLIENT_MODAL';

// ACTION CREATOR setOpenCommandLineClientModal
export const setOpenCommandLineClientModal = (value) => ({
  type: SET_OPEN_COMMAND_LINE_CLIENT_MODAL,
  value,
});

// ACTION CREATOR SET_OPEN_HISTORY_MODAL
export const SET_OPEN_HISTORY_MODAL = 'SET_OPEN_HISTORY_MODAL';

// ACTION CREATOR setOpenHistoryModal
export const setOpenHistoryModal = (value) => ({
  type: SET_OPEN_HISTORY_MODAL,
  value,
});

// ACTION CREATOR FETCH_HEADER
export const FETCH_HEADER = 'FETCH_HEADER';

// ACTION CREATOR fetchHeader
export const fetchHeader = (value, backend) => ({
  type: FETCH_HEADER,
  value,
  backend,
});

// ACTION CREATOR SET_SAVE_DATA_HEADER
export const SET_SAVE_DATA_HEADER = 'SET_SAVE_DATA_HEADER';

// ACTION CREATOR setSaveDataHeader
export const setSaveDataHeader = (value) => ({
  type: SET_SAVE_DATA_HEADER,
  value,
});

// ACTION CREATOR SET_LOADING_HEADER
export const SET_LOADING_HEADER = 'SET_LOADING_HEADER';

// ACTION CREATOR setLoadingHeader
export const setLoadingHeader = (value) => ({
  type: SET_LOADING_HEADER,
  value,
});

// ACTION CREATOR SET_SAVE_HTML_MODAL
export const SET_SAVE_HTML_MODAL = 'SET_SAVE_HTML_MODAL';

// ACTION CREATOR setSaveHtmlModal
export const setSaveHtmlModal = (value) => ({
  type: SET_SAVE_HTML_MODAL,
  value,
});

// ACTION CREATOR SET_OPEN_SAFARI_MODAL
export const SET_OPEN_SAFARI_MODAL = 'SET_OPEN_SAFARI_MODAL';

// ACTION CREATOR setOpenSafariModal
export const setOpenSafariModal = (value) => ({
  type: SET_OPEN_SAFARI_MODAL,
  value,
});
